import {isIntercomBootedAtom} from "@/store/jotaiAtoms";
import useTokenStore from "@/store/token";
import {useNavigate} from "@tanstack/react-router";
import {useSetAtom} from "jotai";
import {useIntercom} from "react-use-intercom";

const ROUTES_WITHOUT_REDIRECT = ["/login", "/logout", "/register"];

export const useLogout = () => {
  const navigate = useNavigate();
  const {shutdown} = useIntercom();
  const setIsIntercomBooted = useSetAtom(isIntercomBootedAtom);

  const logout = async () => {
    // Capture the current page before logout wipes locationAtom, so re-login
    // returns the user here (via the /login redirect param). Guard against open
    // redirects and auth routes.
    const target = `${window.location.pathname}${window.location.search}`;
    const shouldRestore =
      target.startsWith("/") &&
      !target.startsWith("//") &&
      target !== "/" &&
      !ROUTES_WITHOUT_REDIRECT.some(route => target.startsWith(route));

    await useTokenStore.getState().logout();
    shutdown();
    setIsIntercomBooted(false);
    navigate({to: "/login", search: shouldRestore ? {redirect: target} : {}});
  };

  return logout;
};
